import styled from 'styled-components';

import { Sidebar } from '~/components/sidebar';
import AnimatedSlider from '~/components/misc/animated-slider';
import useWizard from '~/components/authentication/wizard/hooks/use-wizard';

import WizardHeader from './header';
import WizardContent from './content';

const SidebarHeight = styled(Sidebar)`
	min-height: calc(100vh - var(--headerHeight) - var(--sidebarHeaderHeight) - var(--subHeaderHeight) - 20px);
`;

const WizardSidebar = ({ children }) => {
	const { direction, step } = useWizard();

	return (
		<AnimatedSlider direction={direction} name="playnow" disableTransition={step.disableTransition}>
			<SidebarHeight className="signup--open">{children}</SidebarHeight>
		</AnimatedSlider>
	);
};

WizardSidebar.Header = WizardHeader;
WizardSidebar.Content = WizardContent;

export default WizardSidebar;
